export default "__VITE_ASSET__B_j2YDfa__"